import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CloseIcon from '../../../icons/CloseIcon';

import useChatContext from '../../../hooks/useChatContext/useChatContext';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      height: '56px',
      background: '#F4F4F6',
      borderBottom: '1px solid #E4E7E9',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 1em',
    },
    text: {
      fontWeight: 'bold',
    },
    closeParticipantWindow: {
      cursor: 'pointer',
      display: 'flex',
      background: 'transparent',
      border: '0',
      padding: '0.4em',
    },
  })
);

export default function ParticipantWindowHeader() {
  const classes = useStyles();
  const { setIsParticipantWindowOpen } = useChatContext();

  return (
    <div className={classes.container}>
      <div className={classes.text}>Résztvevők</div>
      <button className={classes.closeParticipantWindow} onClick={() => setIsParticipantWindowOpen(false)}>
        <CloseIcon />
      </button>
    </div>
  );
}
